import { useState } from 'react';
import { PageHeader } from '@/components/layout/page-header';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Film } from 'lucide-react';
import { GalleryTab } from './components/gallery-tab';
import { DocumentariesTab } from './components/documentaries-tab';
import { ProposalsTab } from './components/proposals-tab';

export default function MediaPage() {
  const [activeTab, setActiveTab] = useState('gallery');

  return (
    <div className="space-y-6 md:space-y-8">
      <PageHeader
        title="Media Center"
        icon={Film}
      />

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-3 lg:w-[600px]">
          <TabsTrigger value="gallery">Gallery</TabsTrigger>
          <TabsTrigger value="documentaries">Documentaries</TabsTrigger>
          <TabsTrigger value="proposals">Proposals</TabsTrigger>
        </TabsList>

        <TabsContent value="gallery" className="mt-6">
          <GalleryTab />
        </TabsContent>

        <TabsContent value="documentaries" className="mt-6">
          <DocumentariesTab />
        </TabsContent>

        <TabsContent value="proposals" className="mt-6">
          <ProposalsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
